import React, {useState} from 'react';
import LocationCode from "../utils/constants/LocationCode";

let LocationSelector = (props) => {
    let [isOpen, setIsOpen] = useState(false)

    return (
        <div className="location-selector-container">
            <div className='location-selector'>
                <div className="text-wrapper">
                    <p id="location">{LocationCode.text[props.location]}</p>
                </div>
                <div className="button-wrapper">
                    <div id="dropdown-button" onClick={() => {
                        setIsOpen(!isOpen)
                    }}>
                    </div>
                </div>
            </div>
            {isOpen ? <div className="location-selector-dropdown">
                    <div className="dropdown-menu" onClick={() => {
                        props.onLocationChange(LocationCode.PNU)
                        setIsOpen(!isOpen)
                    }}>
                        <p className="location-name">부산대점</p>
                    </div>
                    <div className="dropdown-menu" onClick={() => {
                        props.onLocationChange(LocationCode.KSU)
                        setIsOpen(!isOpen)
                    }}>
                        <p className="location-name">경성대점</p>
                    </div>
                </div> : null}
        </div>
    )
}

export default LocationSelector
